/*
  Barra della spedizione gratuita nei mercati con valuta diversa dall'euro (DKK, PLN, RON, SEK).
  La soglia del tema (settings.free_delivery_price) è in euro: qui la si converte con Shopify.currency.rate,
  lo stesso tasso con cui Shopify converte la condizione della tariffa al checkout.
  Lo snippet free-delivery-bar.liquid prepara i dati; questo script li completa anche quando
  carrello e notifiche ridisegnano la barra (MutationObserver).
*/
(function () {
  if (window.__freeDeliveryCurrency) return;
  window.__freeDeliveryCurrency = true;

  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r > 0 ? r : null;
  }

  // sample = 1000,00 formattato da Liquid nella valuta del mercato, per esempio "1.000,00 kr" o "1 000,00 zł"
  function formatter(sample) {
    var m = sample.match(/1([^\d]?)000([^\d])00/);
    if (!m) return null;
    var thousands = m[1], decimal = m[2];
    var before = sample.slice(0, m.index), after = sample.slice(m.index + m[0].length);
    return function (cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      return before + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + parts[1] + after;
    };
  }

  function update(box) {
    var r = rate();
    var format = formatter(box.getAttribute('data-fd-sample') || '');
    if (!r || !format) return;
    var total = parseInt(box.getAttribute('data-fd-total'), 10);
    var threshold = Math.round(parseInt(box.getAttribute('data-fd-threshold'), 10) * r);
    var left = threshold - total;

    var bar = box.previousElementSibling;
    if (bar && bar.classList.contains('free-delivery-bar__toolbar')) bar.style.setProperty('--max-length', threshold);

    var free = box.querySelector('[data-fd-free]');
    var missing = box.querySelector('[data-fd-missing]');
    if (left < 2) {
      free.style.display = '';
      missing.style.display = 'none';
    } else {
      box.querySelector('[data-fd-amount]').textContent = format(left);
      missing.style.display = '';
      free.style.display = 'none';
    }
    box.style.visibility = '';
    box.setAttribute('data-fd-done', '');
  }

  function scan() {
    document.querySelectorAll('[data-fd-local]:not([data-fd-done])').forEach(update);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }

  function start() {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
